export default function TaxationRulesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M7.92913 4.71094H40.072C40.072 4.71094 43.2863 4.71094 43.2863 7.92522V40.0681C43.2863 40.0681 43.2863 43.2824 40.072 43.2824H7.92913C7.92913 43.2824 4.71484 43.2824 4.71484 40.0681V7.92522C4.71484 7.92522 4.71484 4.71094 7.92913 4.71094Z"
        stroke="#3D3D3D"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5.65625 42.3447L42.3448 5.65625"
        stroke="#3D3D3D"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M11.1445 15.9609H20.7874"
        stroke="#3D3D3D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15.9648 20.7835V11.1406"
        stroke="#3D3D3D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M36.8577 32.0312H27.2148"
        stroke="#3D3D3D"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

